import { Box, Typography } from '@mui/material';

const SLICE_CONFIG = {
    sender: {
      borderImage: "url('/img/DialogueUser.png') 30% fill / 12px round",
      padding: '15px 20px',
      marginOffset: '10px'
    },
    receiver: {
      borderImage: "url('/img/DialogueLucy.png') 30% fill / 12px round",
      padding: '15px 20px',
      marginOffset: '10px'
    }
  };

export const ChatBubble = ({ isSender, content }) => {
const config = isSender ? SLICE_CONFIG.sender : SLICE_CONFIG.receiver;
return (
    <Box sx={{ 
      display: 'flex',
      justifyContent: isSender ? 'flex-end' : 'flex-start',
      mb: 2,
      marginLeft: isSender ? '15%' : 0,
      marginRight: isSender ? 0 : '15%',
      transition: 'transform 0.2s ease'
    }}>
      <Box sx={{
        maxWidth: '70%',
        position: 'relative',
        border: '1px solid transparent', 
        borderImage: config.borderImage,
        padding: config.padding,
        color: isSender ? '#ffffff' : '#333333',
        marginLeft: !isSender ? config.marginOffset : 0,
        marginRight: isSender ? config.marginOffset : 0,
        overflowWrap: 'break-word',
        whiteSpace: 'pre-wrap'
      }}>
        <Typography sx={{
          lineHeight: 1.4,
          fontSize: '0.875rem',
          fontFamily: 'inherit'
        }}>
          {content}
        </Typography>
      </Box>
    </Box>
  );
}